// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"131":"b7f92f99","605":"0d532b6c","2352":"3e2d6289","4346":"2f085f81","6294":"1e46f057","7635":"0d532b6c","8597":"14569816","8641":"29606b58"}[chunkId] + ".chunk.css";
};